<template>
    <v-container fluid class="mt-0 pt-0 fill-height appbackground d-flex align-center justify-center">
        <v-row v-if="showInduction" class="fill-height px-2 d-flex align-start align-md-center justify-center" no-gutters>
            <v-col cols="12" xs="12" sm="12" md="12" lg="8" class="">
                <v-progress-linear
                    v-if="$vuetify.breakpoint.smAndDown && sortSlideBySlideOrder.length > 0"
                    class="mt-2 align-center v-progress-linear"
                    background-color="grey"
                    color="darkgrey"
                    height="5"
                    :value="slideProgress"
                ></v-progress-linear>
                <v-progress-linear
                    v-if="$vuetify.breakpoint.mdAndUp && sortSlideBySlideOrder.length > 0"
                    class="mt-5 align-center"
                    background-color="grey"
                    color="darkgrey"
                    height="5"
                    :value="slideProgress"
                ></v-progress-linear>

                <div v-if="$vuetify.breakpoint.smAndDown" class="d-flex align-end mt-8 mb-3">
                    <appbutton
                        class="pr-2"
                        v-if="showEndButtons != true && slideNumber != 0"
                        @click.native="slideNumber--"
                        :label="$t(`buttons.back`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <appbutton
                        v-else-if="showEndButtons === true && slideNumber != 0"
                        @click.native="
                            slideNumber--
                            showEndButtons = false
                        "
                        :label="$t(`buttons.back`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <appbutton
                        class="pl-2"
                        v-if="showEndButtons === true"
                        @click.native="restartInduction()"
                        :label="$t(`buttons.restart`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <v-spacer></v-spacer>
                    <appbutton
                        v-if="showEndButtons != true"
                        @click.native="validateNext"
                        :label="$t(`buttons.next`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <appbutton
                        v-else-if="checkbox === true"
                        @click.native="goToQuiz"
                        label="Proceed to Quiz"
                        type="blue"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <!-- <appbutton v-else-if="checkbox===true" @click.native="submitConfirmation" :label="$t(`buttons.submit`)" type="blue" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> -->
                </div>

                <v-carousel
                    v-if="sortSlideBySlideOrder.length > 0"
                    v-model="slideNumber"
                    :show-arrows="false"
                    hide-delimiters
                    :height="carouselHeight"
                >
                    <v-row class="ma-0 pa-0 ">
                        <v-carousel-item
                            v-for="(item, i) in sortSlideBySlideOrder"
                            :key="i"
                            reverse-transition="fade-transition"
                            class=""
                            transition="fade-transition"
                            style="width: 100% !important"
                            eager
                        >
                            <v-row v-if="$vuetify.breakpoint.mdAndUp" class="ma-0 pa-0 d-flex justify-start" style="width: 100% !important">
                                <v-col class="d-flex justify-start align-start ma-0 pa-0" :cols="item.fileUpload ? '12' : '4'">
                                    <v-img
                                        class="mt-4"
                                        contain
                                        :src="item.slideUrl"
                                        height="100%"
                                        max-height="400px"
                                        style="border-radius: 10px !important;"
                                    ></v-img>
                                </v-col>
                                <v-col v-if="!item.fileUpload" cols="8" md="8" lg="8" class="pl-5">
                                    <div class="text-h6 text-md-h5 text-lg-h5 font-weight-thin d-flex align-center justify-start primary--text">
                                        {{ item.slideName }}
                                    </div>
                                    <div
                                        class="grey--text text-body-2 text-md-body-2 text-lg-body-1 text--darken-2 mt-2 scrollable-description"
                                        v-html="item.slideDesc"
                                        style="max-height: 300px; overflow-y: auto; padding-right: 16px;"
                                    ></div>
                                    <v-checkbox v-if="i === sortSlideBySlideOrder.length - 1" color="primary" v-model="checkbox">
                                        <span slot="label" class="black--text text-body-2">
                                            I confirm that I have read and understood the information from the Induction slides
                                        </span>
                                    </v-checkbox>
                                </v-col>
                            </v-row>

                            <v-row
                                v-if="$vuetify.breakpoint.smAndDown"
                                class="ma-0 pa-0 pb-4 d-flex justify-start "
                                style="max-height: 73vh; overflow-y: auto;"
                            >
                                <v-col class="d-flex justify-start align-start ma-0 pa-0" cols="12" xs="12" sm="6" md="6" lg="6">
                                    <v-img
                                        :width="imageWidth"
                                        contain
                                        :src="item.slideUrl"
                                        style="border-radius: 10px !important; max-height: 40vh;"
                                    ></v-img>
                                </v-col>
                                <v-col cols="12" xs="12" sm="6" md="6" lg="6" class="ma-0 pa-0">
                                    <div class="text-h6 text-md-h5 text-lg-h5 font-weight-thin d-flex mt-3 align-center justify-start primary--text">
                                        <!-- <v-icon x-large class="pr-1" v-if="item.slideIcon" color="primary">{{item.slideIcon}}</v-icon>  -->
                                        {{ item.slideName }}
                                    </div>
                                    <div
                                        class="grey--text text-body-2 text-md-body-2 text-lg-body-1 text--darken-2 mt-1"
                                        v-html="item.slideDesc"
                                    ></div>
                                    <v-checkbox v-if="i === sortSlideBySlideOrder.length - 1" color="primary" v-model="checkbox">
                                        <!-- &&
                                                inductionStatus !== 'valid' -->
                                        <span slot="label" class="black--text text-body-2">
                                            I confirm that I have read and understood the information from the Induction slides</span
                                        >
                                    </v-checkbox>
                                    <div class="d-flex align-end mt-5">
                                        <appbutton
                                            class="pr-2"
                                            v-if="showEndButtons != true && slideNumber != 0"
                                            @click.native="slideNumber--"
                                            :label="$t(`buttons.back`)"
                                            type="secondary"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                            showlabel="xlOnly"
                                        />
                                        <appbutton
                                            v-else-if="showEndButtons === true && slideNumber != 0"
                                            @click.native="
                                                slideNumber--
                                                showEndButtons = false
                                            "
                                            :label="$t(`buttons.back`)"
                                            type="secondary"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                            showlabel="xlOnly"
                                        />
                                        <appbutton
                                            class="pl-2"
                                            v-if="showEndButtons === true"
                                            @click.native="restartInduction()"
                                            :label="$t(`buttons.restart`)"
                                            type="secondary"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                            showlabel="xlOnly"
                                        />
                                        <v-spacer></v-spacer>

                                        <appbutton
                                            v-if="showEndButtons != true"
                                            @click.native="validateNext"
                                            :label="$t(`buttons.next`)"
                                            type="secondary"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                            showlabel="xlOnly"
                                        />
                                        <!-- <appbutton v-else-if="checkbox===true" @click.native="submitConfirmation" :label="$t(`buttons.submit`)" type="blue" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> -->
                                        <appbutton
                                            v-else-if="checkbox === true"
                                            @click.native="goToQuiz"
                                            label="Proceed to Quiz"
                                            type="blue"
                                            iconclass="white--text"
                                            labelclass="white--text"
                                            showlabel="xlOnly"
                                        />
                                    </div>
                                </v-col>
                            </v-row>
                        </v-carousel-item>
                    </v-row>
                </v-carousel>
                <div v-else class="d-flex align-center justify-center mt-5 text-h5 font-weight-thin">
                    NO INDUCTION SLIDES FOUND
                </div>
                <div v-if="$vuetify.breakpoint.mdAndUp && sortSlideBySlideOrder.length > 0" class="d-flex align-end mt-5">
                    <appbutton
                        class="pr-2"
                        v-if="showEndButtons != true && slideNumber != 0"
                        @click.native="slideNumber--"
                        :label="$t(`buttons.back`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <appbutton
                        v-else-if="showEndButtons === true && slideNumber != 0 && sortSlideBySlideOrder.length > 0"
                        @click.native="
                            slideNumber--
                            showEndButtons = false
                        "
                        :label="$t(`buttons.back`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <appbutton
                        class="pl-2"
                        v-if="showEndButtons === true"
                        @click.native="restartInduction()"
                        :label="$t(`buttons.restart`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <v-spacer></v-spacer>
                    <appbutton
                        v-if="showEndButtons != true"
                        @click.native="validateNext"
                        :label="$t(`buttons.next`)"
                        type="secondary"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                    <!-- Complete Induction Button  -->
                    <!-- <appbutton v-else-if="checkbox===true" @click.native="submitConfirmation" :label="$t(`buttons.submit`)" type="blue" iconclass="white--text" labelclass="white--text" showlabel="xlOnly" /> -->
                    <appbutton
                        v-else-if="checkbox === true"
                        @click.native="goToQuiz"
                        label="Proceed to Quiz"
                        type="blue"
                        iconclass="white--text"
                        labelclass="white--text"
                        showlabel="xlOnly"
                    />
                </div>
            </v-col>
        </v-row>
        <v-row v-else class="fill-height px-2 d-flex flex-column align-center justify-center" no-gutters>
            <!-- <pre>Selected site is {{selectedSite}}</pre>
            <pre>Sites {{sites}}</pre> -->
            <v-col cols="12" xs="12" sm="12" md="12" lg="8" class="d-flex align-center justify-center">
                <v-card class="elevation-12" color="white" max-width="600" min-width="400">
                    <v-card-title class="primary--text text-h5 font-weight-thin">Select Site</v-card-title>
                    <v-card-subtitle class="secondary--text text-body1 font-weight-medium"
                        >Please select which Site you wish to complete an Induction for:</v-card-subtitle
                    >
                    <v-card-text>
                        <v-form ref="form" v-model="formValid">
                            <v-row no-gutters>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="d-flex align-center justify-center">
                                    <v-autocomplete
                                        v-model="selectedSite"
                                        :items="sites"
                                        item-text="siteName"
                                        item-value="siteName"
                                        label="Site"
                                        required
                                        :rules="siteSlideRules"
                                        hide-details
                                        dense
                                        filled
                                        return-object
                                    ></v-autocomplete>
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="12" lg="12" class="d-flex align-center justify-center pt-4">
                                    <appbutton
                                        @click.native="validateSite"
                                        :label="$t(`buttons.next`)"
                                        type="secondary"
                                        iconclass="white--text"
                                        labelclass="white--text"
                                        showlabel="xlOnly"
                                    />
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
    // * DATA
    data: () => ({
        collection: 'induction',
        collectionTitle: 'Induction',
        collectionItem: 'induction',
        collectionItemTitle: 'Induction',
        checkbox: false,
        langPath: 'induction',
        theNameOfSites: '',
        slides: [],
        initialSlidesArray: [],
        showEndButtons: false,
        multipleSlideArray: [],
        inductionDate: [],
        sites: [],
        i: 0,
        slideNumber: 0,
        siteSlideRules: [v => !!v || 'The Site name is required'],
        inductionDone: false,
        inductionStatus: '',
        inductionDue: null,
        inductionRenewal: null,
        showInduction: false,
        selectedSite: [],
        sites: [],
        formValid: false
    }),
    // * COMPUTED
    computed: {
        ...mapGetters({
            GET_currentUser: 'GET_currentUser',
            GET_sites: 'GET_sites'
        }),
        // SORT SLIDE BY SLIDE ORDER
        sortSlideBySlideOrder() {
            var t = this
            for (var i = 0; i < t.slides.length; i++) {
                //     if (t.slides[i].slideStatus ==="LIVE") {
                //          for (var j = 0; j < t.slides[i].userType.length; j++) {
                //             if ( t.GET_currentUser.userType == t.slides[i].userType[j] && !t.multipleSlideArray.includes(t.slides[i])){
                t.multipleSlideArray.push(t.slides[i])
                //                 break;
                //             }
                //         }
                //     }
            }
            t.multipleSlideArray.sort(function(a, b) {
                return a.slideOrder - b.slideOrder
            })
            // t.multipleSlideArray.sort((a,b) => (a.slideOrder > b.slideOrder) ? 1 : ((b.slideOrder > a.slideOrder) ? -1 : 0));

            if (t.inductionStatus === 'valid') {
                t.multipleSlideArray.splice(-1, 1)
            }

            return t.multipleSlideArray
        },
        slideProgress() {
            var t = this
            var progress = (t.slideNumber / (t.multipleSlideArray.length - 1)) * 100
            return progress
        },
        imageHeight() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '90vh'
                    break
                case 'sm':
                    return '90vh'
                    break
                default:
                    return '10px'
                    break
            }
        },
        imageWidth() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '90vw'
                    break
                case 'sm':
                    return '90vw'
                    break
                default:
                    return '10px'
                    break
            }
        },
        carouselHeight() {
            // return '100%';
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return '950'
                    break
                case 'sm':
                    return '670'
                    break
                case 'md':
                    return '260px'
                    break
                case 'lg':
                    return '330px'
                    break
                case 'xl':
                    return '420px'
                    break
                default:
                    return '10px'
                    break
            }
        }
    },
    // * METHODS
    methods: {
        // UPDATE BREADCRUMBS
        updateBreadcrumbs() {
            var t = this
            var breadcrumbs = []
            breadcrumbs.push({
                name: `${t.collectionTitle}`,
                path: `/${t.collection}`
            }) // Set the Main Path
            t.MIX_breadcrumbs(breadcrumbs)
        },

        currentUsersInduction() {
            var t = this

            // check users swapped in status
            // if swapped in, check status of induction for site
            // if induction is expired, show induction slides
            // if swapped out, show options to select site

            // get users induction for selectedSite
            // using traditional null checking
            var inductions = t.GET_currentUser.inductions || []
            var induction = inductions.filter(induction => induction.site === t.selectedSite.siteName)

            if (induction && induction.length > 0) {
                var inductionDate2Y = t
                    .$moment(induction[0].date, 'x')
                    .add(2, 'years')
                    .format('x')
                var currentDate = t.$moment().format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days') // 1

                switch (true) {
                    case inductionDue > 0:
                        t.inductionStatus = 'expired'
                        break
                    case inductionDue > -90 && inductionDue < 0:
                        t.inductionStatus = 'due'
                        break
                    case inductionDue === '':
                        t.inductionStatus = 'required'
                    default:
                        t.inductionStatus = 'valid'
                        break
                }
            } else {
                t.inductionStatus = 'notstarted'
            }

            t.showInduction = true

            // if (t.GET_currentUser.inductionDate !== '') {
            //     var inductionDate2Y = t
            // 		.$moment(t.GET_currentUser.inductionDate, "x")
            // 		.add(2, "years")
            // 		.format("x");
            // 	var currentDate = t.$moment().format("x");
            // 	var inductionDue = t.$moment(currentDate, "x").diff(t.$moment(inductionDate2Y, "x"), "days"); // 1

            // 	t.inductionRenewal = inductionDate2Y;
            // 	t.inductionDue = inductionDue;

            // 	switch (true) {
            // 		case inductionDue > 0:
            // 			t.inductionStatus = "expired";
            // 			break;
            // 		case inductionDue > -90 && inductionDue < 0:
            // 			t.inductionStatus = "due";
            // 			break;
            //         case inductionDue === '':
            //             t.inductionStatus = "required"
            // 		default:
            // 			t.inductionStatus = "valid";
            // 			break;
            // 	}
            // } else {
            // 	t.inductionStatus = "notstarted";
            // }
        },

        // READ SLIDE FROM DB
        readSlideFromDB() {
            var t = this
            t.$firebase.db
                .collection('slides')
                .where('slideStatus', '==', 'LIVE')
                .onSnapshot(querySnapshot => {
                    t.slides = []
                    querySnapshot.forEach(doc => {
                        var document = doc.data()
                        document.id = doc.id
                        if (!document.hasOwnProperty('delete')) {
                            if (
                                !document.site ||
                                document.site.length === 0 ||
                                (document.site && document.site.some(site => site.siteId === t.selectedSite.siteId))
                            ) {
                                t.slides.push(document)
                            }
                        }
                    })
                })
        },
        goToQuiz() {
            var t = this
            t.MIX_go('/quiz?site=' + t.selectedSite.siteId)
        },
        // SUBMIT CONFIRMATION
        submitConfirmation: async function(status) {
            var t = this
            var newInductionDate = t.$moment().format('x')
            var updateInductionDate = await t.MIX_updateDocumentFieldsById('users', t.GET_currentUser.id, { inductionDate: newInductionDate })
            if (updateInductionDate.code === 1) {
                t.MIX_alert(1, 'Status Updated', updateInductionDate.data, null)
                t.sendInductionNotif(t.GET_currentUser)
                t.returnToHomePage()
            } else {
                t.MIX_alert(-1, 'ERROR - Could not update Status', null, updateInductionDate.error)
            }
        },

        async sendInductionNotif(user) {
            return new Promise(resolve => {
                let t = this
                const url = 'https://europe-west2-tfw-swapp.cloudfunctions.net/sendCompletedInductionNotification'
                t.$axios
                    .post(url, user)
                    .then(response => {
                        resolve({
                            code: 1,
                            message: 'Induction Details sent to Sponsor',
                            data: response.data,
                            error: null
                        })
                        // t.MIX_alert(1, 'Project Submitted for Review', null, null)
                        t.updateItemStatus('sent')
                    })
                    .catch(error => {
                        resolve({
                            code: -1,
                            message: 'Induction Details not send to Sponsor',
                            data: null,
                            error: error.response.data.error.raw.message
                        })
                        // t.MIX_alert(-1, 'Project Not Submitted for Review', null, null)
                    })
            })
        },
        // RETURN TO HOMEPAGE
        returnToHomePage() {
            var t = this
            setTimeout(function() {
                t.MIX_go('/')
            }, 1000)
        },
        restartInduction() {
            this.slideNumber = 0
            this.showEndButtons = false
        },
        validateNext() {
            var t = this
            var number = t.multipleSlideArray.length - 1
            var slideno = t.slideNumber + 1
            if (slideno >= number) {
                t.slideNumber++
                t.showEndButtons = true
                return
            } else {
                return t.slideNumber++
            }
        },
        validateSite() {
            var t = this
            t.$refs.form.validate()
            if (t.selectedSite) {
                t.showInduction = true
            }
        },
        // Your improved filter function that can be used separately
        getValidInductions() {
            var t = this
            var inductions = t.GET_currentUser.inductions || []
            var hasCantonInductionDate = t.GET_currentUser.inductionDate ? true : false
            var completedSites = inductions.map(induction => induction.site)

            // Add Canton site if user has global Canton induction but not in the inductions array
            if (hasCantonInductionDate && !completedSites.includes('aeKJ3GotwdOBVoA1f2oY')) {
                completedSites.push('aeKJ3GotwdOBVoA1f2oY')
            }

            // Check if induction is still valid
            completedSites = completedSites.filter(site => {
                var induction = inductions.find(induction => induction.site === site)
                var inductionDate2Y

                // Special case for Canton depot induction
                if (site === 'aeKJ3GotwdOBVoA1f2oY') {
                    // User might have global Canton induction but no site-specific one
                    var cantonInductionDate = induction ? induction.date : null

                    if (hasCantonInductionDate && cantonInductionDate) {
                        // We have both dates - use the more recent one
                        if (t.GET_currentUser.inductionDate > cantonInductionDate) {
                            inductionDate2Y = t
                                .$moment(t.GET_currentUser.inductionDate, 'x')
                                .add(2, 'years')
                                .format('x')
                        } else {
                            inductionDate2Y = t
                                .$moment(cantonInductionDate, 'x')
                                .add(2, 'years')
                                .format('x')
                        }
                    } else if (hasCantonInductionDate) {
                        // Only have global inductionDate
                        inductionDate2Y = t
                            .$moment(t.GET_currentUser.inductionDate, 'x')
                            .add(2, 'years')
                            .format('x')
                    } else if (cantonInductionDate) {
                        // Only have site-specific induction
                        inductionDate2Y = t
                            .$moment(cantonInductionDate, 'x')
                            .add(2, 'years')
                            .format('x')
                    } else {
                        // No induction found - shouldn't happen but handle it
                        return false
                    }
                } else if (induction) {
                    // For all other sites, use the site induction date
                    inductionDate2Y = t
                        .$moment(induction.date, 'x')
                        .add(2, 'years')
                        .format('x')
                } else {
                    // No induction found for this site - shouldn't happen but handle it
                    return false
                }

                var currentDate = t.$moment().format('x')
                var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

                return inductionDue < 0
            })

            return completedSites
        }
    },
    watch: {
        selectedSite: {
            handler: function(val) {
                var t = this
                t.readSlideFromDB()
            },
            deep: true
        }
    },
    // * CREATED
    created() {
        var t = this
        // this.readSlideFromDB();
    },
    async mounted() {
        var t = this

        await t.MIX_sites() // UPDATE SITES LIST IN STORE (id, siteName)
        t.sites = t.GET_sites // GET SITES FROM STORE

        var inductions = t.GET_currentUser.inductions || []
        var hasCantonInductionDate = t.GET_currentUser.inductionDate ? true : false
        var sites = t.sites || [] // The full list of available sites
        var originalSites = [...sites] // Keep a copy of all sites
        var completedSites = inductions.map(induction => induction.site)

        // Add Canton site if user has global Canton induction but not in the inductions array
        if (hasCantonInductionDate && !completedSites.includes('aeKJ3GotwdOBVoA1f2oY')) {
            completedSites.push('aeKJ3GotwdOBVoA1f2oY')
        }

        // Check if induction is still valid
        completedSites = completedSites.filter(site => {
            var induction = inductions.find(induction => induction.site === site)
            var inductionDate2Y

            // Special case for Canton depot induction
            if (site === 'aeKJ3GotwdOBVoA1f2oY') {
                // User might have global Canton induction but no site-specific one
                var cantonInductionDate = induction ? induction.date : null

                if (hasCantonInductionDate && cantonInductionDate) {
                    // We have both dates - use the more recent one
                    if (t.GET_currentUser.inductionDate > cantonInductionDate) {
                        inductionDate2Y = t
                            .$moment(t.GET_currentUser.inductionDate, 'x')
                            .add(2, 'years')
                            .format('x')
                    } else {
                        inductionDate2Y = t
                            .$moment(cantonInductionDate, 'x')
                            .add(2, 'years')
                            .format('x')
                    }
                } else if (hasCantonInductionDate) {
                    // Only have global inductionDate
                    inductionDate2Y = t
                        .$moment(t.GET_currentUser.inductionDate, 'x')
                        .add(2, 'years')
                        .format('x')
                } else if (cantonInductionDate) {
                    // Only have site-specific induction
                    inductionDate2Y = t
                        .$moment(cantonInductionDate, 'x')
                        .add(2, 'years')
                        .format('x')
                } else {
                    // No induction found - shouldn't happen but handle it
                    return false
                }
            } else if (induction) {
                // For all other sites, use the site induction date
                inductionDate2Y = t
                    .$moment(induction.date, 'x')
                    .add(2, 'years')
                    .format('x')
            } else {
                // No induction found for this site - shouldn't happen but handle it
                return false
            }

            var currentDate = t.$moment().format('x')
            var inductionDue = t.$moment(currentDate, 'x').diff(t.$moment(inductionDate2Y, 'x'), 'days')

            return inductionDue < 0
        })

        // Handle site filtering logic
        // If some sites are completed but not all, only show incomplete sites
        // If all sites are completed, show all sites
        console.log('Completed sites:', completedSites)
        console.log('Original sites length:', originalSites.length)

        if (completedSites.length > 0 && completedSites.length < originalSites.length) {
            console.log('Filtering sites - showing only sites not completed')
            // Filter out sites that have been completed (comparing site.siteId with completed site IDs)
            t.sites = originalSites.filter(site => !completedSites.includes(site.siteId))
        } else {
            console.log('Showing all sites - all are completed or none are completed')
            t.sites = originalSites
        }

        console.log('Final sites length:', t.sites.length)

        t.updateBreadcrumbs() // Update Breadcrumbs in Title

        // if users swappd in, check induction status for site
        if (t.GET_currentUser.swappStatus == 1) {
            t.selectedSite = t.GET_currentUser.lastSite
            t.currentUsersInduction()
        } else {
            t.showInduction = false
        }
        // t.currentUsersInduction();
    }
}
</script>

<style lang="sass">
@import '~vuetify/src/styles/styles.sass'

@media #{map-get($display-breakpoints, 'md-and-up')}
  .v-progress-linear
      width: 100% !important


@media #{map-get($display-breakpoints, 'sm-and-down')}
  .v-progress-linear
      width: 90vw !important
</style>

<style lang="scss">
.scrollable-description {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
}

.scrollable-description::-webkit-scrollbar {
    width: 6px;
}

.scrollable-description::-webkit-scrollbar-track {
    background: transparent;
}

.scrollable-description::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}

.scrollable-description::-webkit-scrollbar-thumb:hover {
    background-color: rgba(0, 0, 0, 0.5);
}
</style>
